import { Validator, install as VeeValidate } from 'vee-validate/dist/vee-validate.minimal.esm.js';
import { max, min, email, confirmed, required, numeric, decimal, min_value, max_value, date_between, date_format } from 'vee-validate/dist/rules.esm';
import veeEn from 'vee-validate/dist/locale/en';
import Vue from 'vue';
import {format} from 'date-fns';

Validator.extend('required', required);
Validator.extend('min', min);
Validator.extend('max', max);
Validator.extend('email', email);
Validator.extend('confirmed', confirmed);
Validator.extend("decimal", decimal);
Validator.extend("min_value", min_value);
Validator.extend("max_value", max_value);
Validator.extend("date_between", date_between);
Validator.extend("date_format", date_format);

const datesBetween = (_, dates) => {
    return `Date must be between ${dates[0]} and ${dates[1]}`;
}

const dictionary = {
	custom: {
        activityName: {
            required: "Please enter an activity name",
        },
        arrivalDate: {
            required: "Please enter an arrival date",
            date_between: datesBetween,
        },
        departureDate: {
            required: "Please enter a departure date",
            date_between: datesBetween,
        },
		name: {
			required: 'Please enter a name',
		},
		email: {
			required: 'Please enter an email address',
			email: 'Please enter a valid email address',
		},
		sector: {
			required: 'Please select a sector',
		},
		sectors: {
			required: 'Please select at least one sector',
		},
		lead: {
			required: 'Please select a lead user',
		},
		team: {
			required: 'Please select at least one team member',
		},
		opportunity: {
			required: 'Please select an opportunity',
		},
		companyName: {
			required: 'Please enter a company name',
		},
		projectName: {
			required: 'Please enter a project name',
		},
		counterpartCompany: {
			required: 'Please enter a counterpart company',
		},
		dealType: {
			required: 'Please select a deal type',
		},
		region: {
			required: 'Please select a region',
		},
		country: {
			required: 'Please select a country',
		},
		location: {
			required: 'Please enter a location',
		},
		summary: {
			required: 'Please enter a summary',
		},
		currency: {
			required: 'Please select a currency',
		},
		activity: {
			required: 'Please enter a company bio',
		},
		dealSummary: {
			required: 'Please enter a deal summary',
		},
		logo: {
			required: 'Please upload a company logo',
		},
		hqCountry: {
			required: 'Please select a country for the company HQ',
		},
		hqLocation: {
			required: 'Please enter a location for the company HQ',
		},
		officeCountry: {
			required: 'Please select a country for this office',
		},
		officeLocation: {
			required: 'Please enter a location for this office',
		},
		firstName: {
			required: 'Please enter a first name',
		},
		lastName: {
			required: 'Please enter a surname',
		},
		position: {
			required: 'Please enter a position',
		},
		specialisms: {
			required: 'Please select at least one sector',
		},
		avatar: {
			required: 'Please upload an avatar',
		},
		office: {
			required: 'Please select an office',
		},
		member: {
			required: 'Please select a member company',
		},
		zip: {
			required: 'Please upload a zip file',
		},
		csv: {
			required: 'Please upload a csv file',
		},
		currentPassword: {
			required: 'Please enter your current password',
		},
		newPassword: {
			required: 'Please enter a new password',
		},
		confirmPassword: {
			required: 'Please enter your new password again',
		},

	},
};

Validator.localize('en', veeEn);
Validator.localize('en', dictionary);

Vue.use(VeeValidate, {
	fieldsBagName: 'formFields',
	fastExit: true,
	events: '',
	classes: true,
	classNames: {
		touched: 'form__control--touched',
		untouched: 'form__control--untouched',
		valid: 'form__control--valid',
		invalid: 'form__control--invalid',
		pristine: 'form__control--pristine',
		dirty: 'form__control--dirty'
	},
});
